module.exports = __webpack_public_path__ + "img/matcha01_300px.c8d31d51.jpg";